export default __webpack_public_path__ + "8ee50d386598ee8c5e065536026778b6.png";